// extracted by mini-css-extract-plugin
module.exports = {"cardsContainer":"CardsContainer_cardsContainer__2MFRG"};